import { render, staticRenderFns } from "./Survey-ThankYou.vue?vue&type=template&id=e5a1007c&scoped=true&"
import script from "./Survey-ThankYou.vue?vue&type=script&lang=js&"
export * from "./Survey-ThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.registry.npmjs.org/vue-loader/15.9.8_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a1007c",
  null
  
)

export default component.exports